import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useQuery, useMutation } from "@apollo/client";
import {
  CREATE_RIGHT,
  UPDATE_RIGHT,
  ALL_MODULES,
} from "../../../data/RoleManagementData"; // Import your GraphQL queries and mutations
import swal from "sweetalert";
import { useState, useEffect } from "react";
import Header from "../../../components/Header";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";
import { allCompanies } from "../../../data/Axios/queries";
import { setupManagementUrl } from "../../../config";
import { executeDynamicSubmit, fetchJsonDynamic } from "../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const setup_url = setupManagementUrl.uri;

const DisbursementMethodsForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [industryTypes, setIndustryTypes] = useState([]);

  const initialValues = {
    methodName: props.data ? props.data.MethodName : "",
  };

  const validationSchema = yup.object().shape({
    methodName: yup.string().required("Disbursment Method Name required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const variables = props.isEditing
      ? { id: props.data.Id, ...values }
      : values;

    await executeDynamicSubmit({
      mutationName: props.isEditing ? "updateDisbursmentMethods" : "createDisbursmentMethods",
      variables,
      mutationObjectName: "result",
      baseUrl: setup_url,
      isEditing: props.isEditing,
      entityName: "Disbursement Method",
      onSuccess: () => {
        props.onClose();
        props.onAction();
      },
      setSubmitting,
    });
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Disbursment Method" : "Create Disbursment Method"}
        subtitle={
          props.isEditing
            ? "Edit an Existing Disbursment Method"
            : "Create a New Disbursment Method"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Method Name*"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.methodName}
                name="methodName"
                error={touched.methodName && !!errors.methodName}
                helperText={touched.methodName && errors.methodName}
                sx={{ gridColumn: "span 2" }}
              />

            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default DisbursementMethodsForm;
